import request from '../utils/request';

//城市列表
export function getCityList(data) {
    return request({
        url: 'home/city/list',
        method: 'post',
        data: data,
    });
}
//新增
export function addCity(data) {
    return request({
        url: 'home/city/add_city',
        method: 'post',
        data: data,
    });
}
//新增
export function searchCity(data) {
    return request({
        url: 'home/city/get_city_area',
        method: 'post',
        data: data,
    });
}

